<template>
	<div :class="getClasses"
		:key="'message-counter-' + deliverable.id + '-' + deliverable.total_unread_messages_in_conversation">
		<span class="message-count" v-if="deliverable.total_unread_messages_in_conversation > 0"
			v-html="deliverable.total_unread_messages_in_conversation"></span>
		<img v-if="deliverable.total_unread_messages_in_conversation > 0 && !deliverable.is_master"
			src="@/csmworkflow/img/chat-bubbles-unread.svg" class="chat-bubbles-unread" />
	</div>
</template>
<style scoped>
.message-counter {
	text-align: center;
	color: var(--wf-tertiary);
	font-weight: 600;
	position: absolute;
	cursor: pointer;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	display: inline-flex;
	align-items: center;
	justify-content: center;
}

.message-counter:hover {
	background: var(--secondary-tertiary-mix95);
}

.message-counter img {
	max-width: 50px;
}

.message-count {
	position: absolute;
	transform: translate(-50%, -25%);
	color: var(--wf-secondary);
	font-size: 1rem;
}
</style>

<script>

export default {
	data() {
		return {

		}
	},
	props: ['deliverable'],
	computed: {
		getClasses() {
			let classes = "message-counter";
			if (this.deliverable) {
				if (this.deliverable.is_master) {
					classes += " is-master";
				}
			}
			return classes;
		}
	},
}
</script>